import gql from "graphql-tag";

export const PRODUCT_CATEGORY = gql`query ($id: ID!) {
    productCategory(id: $id) {
        id
        name
        order
        isDeleted
    }
}`;

export const CREATE_PRODUCT_CATEGORY = gql`mutation ($input: ProductCategoryInput!) {
    createProductCategory(
        input: $input
    ) {
        id
        name
        order
    }
}`;

export const UPDATE_PRODUCT_CATEGORY = gql`mutation ($id: ID! $input: ProductCategoryInput!) {
    updateProductCategory(
        id: $id
        input: $input
    ) {
        id
        name
        order
    }
}`;

export const DELETE_PRODUCT_CATEGORY = gql`mutation ($id: ID!) {
    deleteProductCategory(
        id: $id
    ) {
        id
    }
}`;

export const REORDER_PRODUCT_CATEGORIES = gql`mutation ($inputs: [ReorderInput!]!) {
    reorderProductCategories(
        inputs: $inputs
    ) {
        id
        order
    }
}`;
